import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import Table from "@/common/components/Table";
import TextField from "@/common/components/TextField";
import { useRoles } from "@/common/hooks/queries/useRoles";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { RoleData, RoleTableItem } from "@/common/types/roles";
import { defaultColumns } from "@/features/tcardRoles/constants/columns.constant";
import { RolesTransformer } from "@/features/tcardRoles/services/rolesTransformer";
import { SearchIcon, WandSparklesIcon } from "lucide-react";

const TcardRoles = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: roles,
    meta,
    isPending: rolesIsPending,
    isLoading: rolesIsLoading,
    error: rolesError = {} as any,
    refetch: refetchRoles,
  } = useRoles({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<RoleData[], RoleTableItem[]>({
      transformer: RolesTransformer.tableTransformer()
    })
  });

  return (
    <div className="flex flex-col gap-6">
      <ListHeader
        Icon={<WandSparklesIcon className="w-10 h-10" strokeWidth={1} />}
        title="Cargos e permissões - Tcard"
        createButtonText="Novo cargo"
        dataTestid="create_roles_button"
        disableCreateButton={rolesIsPending || rolesError?.status === 403}
      />

      <ErrorMessageWrapper
        className="h-[calc(100vh-128px)]"
        statusCode={rolesError?.status}
        refetchFunction={refetchRoles}
      >
        <div className="h-[calc(100vh-128px)] flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
              }}
              value={filterParams.search}
            />
          </div>

          <Table
            className="max-h-screen"
            columns={defaultColumns}
            isLoadingData={rolesIsLoading}
            page={filterParams.page || 1}
            rows={roles}
            totalPages={meta.total_pages}
            totalCount={meta.total}
            hasPagination
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default TcardRoles;
